/**
 * HTX (Huobi) timeframe configuration and interval mapping.
 * Supported intervals: 1min, 5min, 15min, 30min, 60min, 4hour, 1day, 1mon, 1week, 1year
 * @see https://www.htx.com/en-us/opend/newApiPages/?id=7ec4b6f3-7773-11ed-9966-0242ac110003
 */

import {
  registerExchangeTimeframes,
  resolutionToSeconds,
  type TimeframeConfig,
} from '../../lib/timeframes';

/**
 * HTX supports 1-minute minimum.
 */
export const HTX_TIMEFRAMES: TimeframeConfig = {
  native: ['1min', '5min', '15min', '30min', '60min', '4hour', '1day', '1week', '1mon', '1year'],
  synthetic: ['1s'], // 1-second synthetic via ticker subscription and bar expansion
  minIntervalSeconds: 1,
};

// Register with central registry
registerExchangeTimeframes('htx', HTX_TIMEFRAMES);

/**
 * Maps TradingView resolution to HTX interval format.
 */
export const mapToHtxInterval = (resolution: string): string => {
  const seconds = resolutionToSeconds(resolution);

  if (seconds === 60) return '1min';
  if (seconds === 300) return '5min';
  if (seconds === 900) return '15min';
  if (seconds === 1800) return '30min';
  if (seconds === 3600) return '60min';
  if (seconds === 14400) return '4hour';
  if (seconds === 86400) return '1day';
  if (seconds === 604800) return '1week';
  if (seconds === 2592000) return '1mon';

  // Default to closest
  if (seconds < 60) return '1min';
  return '60min';
};
